/**
 * @Author Awen
 * @Date 2024/06/01
 * @Email wengaolng@gmail.com
 **/

import Click from "./components/Click/Index";
import Slide from "./components/Slide/Index";
import SlideRegion from "./components/SlideRegion/Index";
import Rotate from "./components/Rotate/Index";
import Button from "./components/Button/Index";

export { Click, Slide, SlideRegion, Rotate, Button };
export default {
  Click,
  Slide,
  SlideRegion,
  Rotate,
  Button,
}
